import { Box, Typography, Button, styled } from "@mui/material";
import { useNavigate } from "react-router-dom";

const PrimaryButton = styled(Button)({
  background: "linear-gradient(90deg, #2A7BFF 0%, #3F8CFF 100%)",
  color: "white",
  padding: "10px 24px",
  borderRadius: 8,
  textTransform: "none",
  fontWeight: 600,
  fontSize: 14,
  "&:hover": {
    background: "linear-gradient(90deg, #1D63E8 0%, #2A7BFF 100%)",
  },
});

export default function SubscribeCancel() {
  const navigate = useNavigate();

  return (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="60vh" gap={2}>
      <Typography variant="h5" fontWeight={700}>
        Checkout canceled
      </Typography>
      <Typography color="text.secondary">No changes were made to your subscription.</Typography>
      <PrimaryButton onClick={() => navigate("/subscribe")}>Back to plans</PrimaryButton>
    </Box>
  );
}